const app = {
  state: {
    waiting: true,
    path: "",
  },
  mutations: {
    SET_WAITING: (state, waiting) => {
      state.waiting = waiting;
    },
    SET_PATH: (state, path) => {
      state.path = path;
    },
  },

  actions: {
    // 设置加载中
    setWaiting({ commit }) {
      return new Promise((resolve) => {
        commit("SET_WAITING", true);
        resolve();
      });
    },
    // 设置当前路径
    setPath({ commit },path) {   
      return new Promise((resolve) => {
        commit("SET_PATH", path);
        resolve();
      });
    },
  },
};

export default app;
